import { Link as MuiLink, Stack as MuiStack } from "@mui/material";
import { GetApp as MuiGetAppIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const DownloadFailedLink = ({ row, downloadFile }) => {
  const { t } = useTranslation();
  const { numRowsFailed, links } = row;

  const failedFileLink = links?.find(
    (link) => link.rel === t("ois.actions.downloadFailed"),
  )?.href;

  if (failedFileLink) {
    return (
      <MuiLink
        component="button"
        href={failedFileLink}
        onClick={(event) => {
          event.preventDefault();
          downloadFile(failedFileLink);
        }}
        sx={{ textDecoration: "none" }}
      >
        <MuiStack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 0.5,
          }}
        >
          {numRowsFailed}
          <MuiGetAppIcon sx={{ fontSize: "20px" }} />
        </MuiStack>
      </MuiLink>
    );
  }

  return numRowsFailed;
};

export default DownloadFailedLink;
